"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const UserRegistrationContext_1 = require("@/context/UserRegistrationContext");
const Shared_1 = require("@/components/styled-controls/Shared");
const TextInput_1 = __importDefault(require("@/components/atoms/TextInput"));
const constant_1 = require("@/constants/constant");
const useApiService_1 = require("@/api/useApiService");
const Layout_1 = __importDefault(require("@/components/organisms/Layout"));
const blue_success_svg_1 = __importDefault(require("@/assets/blue-success.svg"));
const Input_1 = require("@/components/styled-controls/Input");
const ValidationHelper_1 = require("@/helpers/ValidationHelper");
const js_cookie_1 = __importDefault(require("js-cookie"));
const PushFormSuccessValuestoDataLayer_1 = require("@/helpers/PushFormSuccessValuestoDataLayer");
const PasswordAndCodeRegistration = () => {
    const { setStep, userData, setUserData, appProps } = (0, UserRegistrationContext_1.useUserRegistration)();
    const { subscriptionApiUrl, analyticsPrefix, freemiumExtranetId } = appProps;
    const [password, setPassword] = (0, react_1.useState)('');
    const [code, setCode] = (0, react_1.useState)('');
    const [validationError, setValidationError] = (0, react_1.useState)('');
    const [codeValidationError, setCodeValidationError] = (0, react_1.useState)('');
    const [passwordValidationError, setPasswordValidationError] = (0, react_1.useState)(null);
    const [isProceedButtonDisabled, setIsProceedButtonDisabled] = (0, react_1.useState)(true);
    /**
     * State variable for tracking whether the form has been submitted.
     * This is used to control the display of validation messages.
     * Validation messages are only displayed once the form has been submitted.
     * This helps to improve the user experience by not showing validation errors before the user has had a chance to complete the form.
     */
    const [isSubmitted, setIsSubmitted] = (0, react_1.useState)(false);
    const { userService, handleResponse } = (0, useApiService_1.useApiService)();
    // Seconds until "Click to resend" is available again. Each resend invalidates the previous code and emails can
    // arrive out of order, so a pause keeps the user from racing their own codes. It starts when the step opens,
    // because a code was just emailed, and the server applies the same cooldown (see RESEND_CODE_COOLDOWN_SECONDS).
    const [resendCooldownSeconds, setResendCooldownSeconds] = (0, react_1.useState)(constant_1.RESEND_CODE_COOLDOWN_SECONDS);
    const isResendCoolingDown = resendCooldownSeconds > 0;
    // The "New code sent" confirmation is only for a resend, not for the code sent when the step opened
    const [hasResentCode, setHasResentCode] = (0, react_1.useState)(false);
    // The cooldown only starts once a resend succeeds, so this stops a double click from sending a second request
    const [isResending, setIsResending] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!isResendCoolingDown) {
            return undefined;
        }
        const intervalId = setInterval(() => setResendCooldownSeconds((seconds) => Math.max(seconds - 1, 0)), 1000);
        return () => clearInterval(intervalId);
    }, [isResendCoolingDown]);
    // Points the user at "Click to resend" once their code is locked
    const [isResendHighlighted, setIsResendHighlighted] = (0, react_1.useState)(false);
    // The email has used its daily allowance of guesses; no code, new or old, can succeed for 24 hours
    const [isDailyLimitReached, setIsDailyLimitReached] = (0, react_1.useState)(false);
    // Define an object to map error codes to their respective error handling functions
    const errorHandler = {
        validationErrorsSetters: [setValidationError, setCodeValidationError, setPasswordValidationError],
        fields: {
            code: {
                stateSetter: setCodeValidationError,
            },
            password: {
                stateSetter: setPasswordValidationError,
            },
            general: {
                stateSetter: setValidationError,
            },
        },
    };
    /**
     * Handles the success response from the backend API.
     * If a token is present in the response data, it is stored in the local storage.
     * Otherwise, sets a validation error.
     * @param data - The response data from the backend API.
     */
    const successHandler = (data) => {
        if (data?.UserId) {
            setUserData((prevData) => ({ ...prevData, id: data.UserId }));
            createCookieForRemainingSteps();
            setStep('basicInfo');
            //Push data to data layer only if successfully submitted
            (0, PushFormSuccessValuestoDataLayer_1.pushFormSuccessValuestoDataLayer)({
                'form-name': `${constant_1.AMPLITUDE_IDENTIFY_TAGS.FORM}-verification`,
                email: userData.email,
                id: data.UserId,
            });
        }
        else {
            setValidationError(constant_1.SOMETHING_WENT_WRONG_ERROR);
        }
    };
    /**
     * Creates a cookie to track the remaining steps in the freemium registration process.
     * This cookie is needed to know if user info is filled out or not.
     * When demographic user info is NOT submitted and a user is logged in, the cookie is used to display the onboarding steps on pro pages.
     * Once demographic user info is submitted, the freemium cookie for the remaining steps is deleted as we only show the popup when demographic user info is not submitted.
     */
    const createCookieForRemainingSteps = () => {
        js_cookie_1.default.set(constant_1.FREEMIUM.COOKIE_NAME, constant_1.FREEMIUM.REMAINING_STEPS.DEMOGRAPHICS, {
            expires: constant_1.FREEMIUM.COOKIE_EXPIRY,
            domain: constant_1.FREEMIUM.COOKIE_DOMAIN,
        }); // Set a cookie that lasts for a year
    };
    /**
     * Handles the success response for resending code.
     * The resend invalidates the previous code, so the code input is cleared (the password is kept)
     * and the user is told to use the code from the most recent email.
     * Otherwise, sets a validation error.
     * @param data - The response data from the backend API.
     */
    const codeSuccessHandler = (data) => {
        if (data) {
            setCode('');
            setCodeValidationError('');
            setValidationError('');
            setIsResendHighlighted(false);
            setIsProceedButtonDisabled(true);
            setHasResentCode(true);
            setResendCooldownSeconds(constant_1.RESEND_CODE_COOLDOWN_SECONDS);
        }
        else {
            setValidationError(constant_1.SOMETHING_WENT_WRONG_ERROR);
        }
    };
    const validateCode = (code) => {
        if (!code) {
            setCodeValidationError(constant_1.INVALID_CODE_ERROR);
            return false;
        }
        setCodeValidationError('');
        return true;
    };
    const validatePassword = (password) => {
        const [isValid, passwordError] = (0, ValidationHelper_1.isValidPassword)(password);
        if (!isValid) {
            setPasswordValidationError(passwordError);
            return false;
        }
        setPasswordValidationError('');
        return true;
    };
    /**
     * Handles the next step in the user registration process.
     * Validates the code and password before submitting the password to the server.
     * Displays error messages if validation fails or an error occurs during submission.
     */
    const handleNext = async (e) => {
        e.preventDefault();
        setIsSubmitted(true);
        setIsProceedButtonDisabled(true);
        setValidationError('');
        if (!validateCode(code) || !validatePassword(password)) {
            setIsProceedButtonDisabled(false);
            return;
        }
        // A locked code cannot succeed even if it is right, so the input is cleared and Create Account stays
        // disabled until the user enters the code from a new email.
        // At the daily limit nothing can succeed for 24 hours, so both Create Account and resend stay disabled.
        let isCodeLocked = false;
        const submitErrorHandler = {
            ...errorHandler,
            errorcode: {
                [constant_1.VERIFICATION_CODE_LOCKED_ERROR_CODE]: {
                    callback: (message) => {
                        isCodeLocked = true;
                        setCode('');
                        setCodeValidationError(message);
                        setIsResendHighlighted(true);
                    },
                },
                [constant_1.VERIFICATION_CODE_DAILY_LIMIT_ERROR_CODE]: {
                    callback: (message) => {
                        isCodeLocked = true;
                        setCode('');
                        setCodeValidationError(message);
                        setIsResendHighlighted(false);
                        setIsDailyLimitReached(true);
                    },
                },
            },
        };
        try {
            const urlParams = new URLSearchParams(globalThis.location.search);
            // uid and t (createdOn timestamp) are needed for referral tracking acceptance
            const uid = urlParams.get('uid');
            const createdOnTimeStamp = urlParams.get('t');
            const response = await userService.submitPassword(`${subscriptionApiUrl}/CompleteRegistration`, userData.email, code, password, freemiumExtranetId, uid || '', createdOnTimeStamp || '');
            await handleResponse(response, successHandler, submitErrorHandler);
        }
        catch (error) {
            setValidationError(constant_1.SOMETHING_WENT_WRONG_ERROR);
        }
        finally {
            setIsProceedButtonDisabled(isCodeLocked);
        }
    };
    /**
     * Handles the resending of code
     * Displays error messages if validation fails or an error occurs during submission.
     * NOTE: DMCS Flow uses Registration endpoint for resending code and we are reusing the same logic.
     */
    const resendCode = async () => {
        setIsResending(true);
        try {
            const response = await userService.resendCode(`${subscriptionApiUrl}/ResendVerificationCode`, userData.email, freemiumExtranetId);
            await handleResponse(response, codeSuccessHandler, errorHandler);
        }
        catch (error) {
            setValidationError(constant_1.SOMETHING_WENT_WRONG_ERROR);
        }
        finally {
            setIsResending(false);
        }
    };
    return (react_1.default.createElement(Layout_1.default, { registrationStepCopy: constant_1.HEADER_TEXTS.CODE_AND_PASSWORD.TITLE, subHeaderText: constant_1.HEADER_TEXTS.CODE_AND_PASSWORD.SUBTITLE(userData.email), errorText: validationError },
        react_1.default.createElement(Input_1.RegistrationForm, { onSubmit: handleNext, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.FORM}-submitted`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.FORM}-submitted` },
            react_1.default.createElement(TextInput_1.default, { type: "text", value: code, onChange: (value) => {
                    setCode(value);
                    setIsProceedButtonDisabled(isDailyLimitReached || !(value && password));
                    if (isSubmitted && !isDailyLimitReached) {
                        validateCode(value);
                    }
                }, validationError: codeValidationError, placeholder: constant_1.PLACEHOLDER_TEXTS.CODE_AND_PASSWORD.CODE, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-code-submitted`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-code-submitted` }),
            react_1.default.createElement(TextInput_1.default, { type: "password", value: password, onChange: (value) => {
                    setPassword(value);
                    setIsProceedButtonDisabled(isDailyLimitReached || !(code && value));
                    if (isSubmitted) {
                        validatePassword(value);
                    }
                }, validationError: passwordValidationError, placeholder: constant_1.PLACEHOLDER_TEXTS.CODE_AND_PASSWORD.PASSWORD, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-password-submitted`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-password-submitted` }),
            react_1.default.createElement(Shared_1.PasswordRequirements, null, "Your password must be 7 to 14 characters long and include at least one letter and one number. Passwords cannot exceed 14 characters."),
            react_1.default.createElement(Shared_1.ButtonContainer, null,
                react_1.default.createElement(Shared_1.StyledButton, { forwardedAs: "button", buttonType: "default", dataAnalytics: constant_1.DATA_ANALYTICS_TAG.CODE_AND_PASSWORD.CREATE_ACCOUNT(analyticsPrefix), size: "m", disabled: isProceedButtonDisabled, "$isDisabled": isProceedButtonDisabled, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-create-submitted`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-create-submitted` }, "Create Account"))),
        react_1.default.createElement(Shared_1.ReceiveCodeWrapper, null,
            hasResentCode && isResendCoolingDown && (react_1.default.createElement(Shared_1.SuccessElement, null,
                react_1.default.createElement("img", { src: blue_success_svg_1.default, alt: "Success" }),
                react_1.default.createElement("span", null, constant_1.RESEND_CODE_SUCCESS_MESSAGE))),
            react_1.default.createElement(Shared_1.StepPrompt, null, "Didn't receive the email?"),
            react_1.default.createElement(Shared_1.ResendCode, { forwardedAs: "button", buttonType: "none", callback: resendCode, disabled: isResendCoolingDown || isResending || isDailyLimitReached, "$isHighlighted": isResendHighlighted, dataAnalytics: constant_1.DATA_ANALYTICS_TAG.CODE_AND_PASSWORD.RESEND(analyticsPrefix), size: "m", target: "_blank", id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-resendcode-submitted`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-resendcode-submitted` }, isResendCoolingDown ? `Resend in ${resendCooldownSeconds}s` : 'Click to resend'))));
};
exports.default = PasswordAndCodeRegistration;
